@if(dialogElementIsSupported ){
  <dialog  id="{{modalId}}" #dialog>
    <div style="display: flex; width: 100%; justify-content: center;">
      <img alt="" src="/assets/images/alert.svg" width="50px">
    </div>
    
    <p class="modal-header" i18n>Are you sure you want to leave this page?</p>
    <p class="modal-body">{{returnText}}</p>
    <div style="display: flex; width: 100%; justify-content: center; gap: 10px;">
      <button id="{{confirmButtonId}}" (click)="confirm()" i18n>Leave this page</button>
      <button id="{{cancelButtonId}}" (click)="cancel()" i18n>Stay on this page</button>
    </div>

  </dialog>
}